export enum ECHO_EVENT {
  CHAT_MESSAGE_EVENT = 'Chat\\ChatMessageEvent',
  CHAT_SEEN_EVENT = 'Chat\\ChatSeenEvent',
  CHAT_TYPING_EVENT = 'Chat\\ChatTypingEvent',
}
